import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { ToolbarModule } from "primeng/toolbar";
import { ButtonModule } from "primeng/button";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { TooltipModule } from "primeng/tooltip";
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { CalendarModule } from "primeng/calendar";
import { BalanceteComponent } from "./balancete.component";
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';

@NgModule({
    declarations: [
        BalanceteComponent
    ],
    imports: [
        TableModule,
        ToolbarModule,
        ButtonModule,
        FormsModule,
        CommonModule,
        ToastModule,
        ConfirmDialogModule,
        InputTextModule,
        TooltipModule,
        SpinnerServiceComponent,
        CalendarModule,
        ToolbarSearchComponent
    ]
})

export class BalanceteModule { }